import React, { ComponentProps, ComponentType } from 'react';

import ReactContentLoader from 'react-content-loader';

import theme, {
  flattenStyle,
  stylePropType,
  StyleProp,
} from '@adsk/alloy-react-theme';

export type ContentLoaderProps = Omit<
  ComponentProps<typeof ReactContentLoader>,
  'style'
> & {
  style?: StyleProp;
};

/**
 * A ContentLoader provides wrapper for react-content-loader
 * API: https://github.com/danilowoz/react-content-loader
 */
const ContentLoader: ComponentType<ContentLoaderProps> = ({
  height,
  width,
  children,
  style,
  ...props
}) => (
  <ReactContentLoader
    speed={2}
    width={width}
    height={height}
    viewBox={
      width !== undefined && height !== undefined
        ? `0 0 ${width} ${height}`
        : undefined
    }
    backgroundColor={theme.tokens.colors.skeleton.shimmer.one.value}
    foregroundColor={theme.tokens.colors.skeleton.shimmer.two.value}
    style={flattenStyle(style)}
    {...props}
  >
    {children}
  </ReactContentLoader>
);

ContentLoader.displayName = 'ContentLoader';

ContentLoader.propTypes = {
  ...ReactContentLoader.propTypes,
  style: stylePropType,
};
export default ContentLoader;
